import analytics from '@/shared-utils/analytics'
import { GA4ProductMap, type GA4ProductType } from '@/ga4types'

type ProductType = 1 | 5 | 8

function fireGA4EventWithCommonAttributes(
  event: 'select_promotion' | 'view_promotion',
  additionalAttributes: {
    product_name: GA4ProductType
    promotion_name?: GA4ProductType
    ecommerce?: {
      transaction_id: string
    }
  }
) {
  analytics.fireGA4Event({
    event,
    attributes: {
      type: 'xsell',
      page_name: 'homepage',
      ...additionalAttributes
    }
  })
}

export function fireViewPromotionXsell(
  productName: 1 | 5 | 8,
  offerId?: string
) {
  fireGA4EventWithCommonAttributes('view_promotion', {
    product_name: GA4ProductMap[productName],
    ...(offerId ? { ecommerce: { transaction_id: offerId } } : null)
  })
}

export function fireViewTripClick() {
  analytics.fireGA4Event({
    event: 'internal_link',
    attributes: {
      link_name: 'view_my_trip',
      page_name: 'homepage'
    }
  })
}

export function fireViewPromotionClick(
  product: ProductType,
  xSellProduct: ProductType,
  offerId: string
) {
  fireGA4EventWithCommonAttributes('select_promotion', {
    product_name: GA4ProductMap[product],
    promotion_name: GA4ProductMap[xSellProduct],
    ecommerce: {
      transaction_id: offerId
    }
  })
}

export function fireGetHelpClick(product: ProductType) {
  analytics.fireGA4Event({
    event: 'internal_link',
    attributes: {
      type: 'penny',
      link_name: 'get_help',
      page_name: 'homepage',
      product_name: GA4ProductMap[product]
    }
  })
}

export function fireAppHandoffBannerDisplay() {
  analytics.fireGA4Event({
    event: 'display',
    attributes: {
      type: 'your_upcoming_trips',
      item_name: 'app_download',
      page_name: 'homepage'
    }
  })
}

export function fireAppHandoffBannerClick() {
  analytics.fireGA4Event({
    event: 'internal_link',
    attributes: {
      type: 'your_upcoming_trips',
      item_name: 'app_download',
      page_name: 'homepage'
    }
  })
}
